<style>

  .Start {
    background-color: #dc3545 !important;
    color: white;
  }

</style>


<div class="col-md-12 mb-30" >
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Ongoing Proficiency Tests</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Title</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_AzmoonMaharat()" class="btn btn-info" style="margin-right: 5px;"><i
              class="fa  fa-search"></i> Search </button>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Registration ID</th>
              <th>Behfa Code</th>
              <th>Code</th>
              <th>Title</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_AzmoonMaharat
            |filter:Filter_title:'title'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_AzmoonMaharat|filter:Filter_title:'title').length
                      }
            ">
              <td>{{DataList_AzmoonMaharat.indexOf(item)+1}}</td>
              <td>{{item.id}}</td>
              <td>{{item.code}}</td>
              <td>{{item.codeBehfa}}</td>
              <td>{{item.title}}</td>
              <td>
                <span *ngIf="item.status.length==0">Inactive</span>

                <ng-container *ngFor="let status of item.status">

                  <button (click)="openModalFile(templateFile,status)" *ngIf="status.canSubmit && !Procssing" type="button" class="btn btn-success" style="margin-top: 10px;">
                    {{status.title}}
                  </button>
                  
                  
                  <button *ngIf="!status.canSubmit || Procssing" type="button" class="btn btn-danger" style="margin-top: 10px;cursor: not-allowed;">
                    {{status.title}}
                  </button>

                  <br/>


                </ng-container>


              </td>
              <td>
                <button (click)="openModal(template,item)"  type="button" class="btn btn-warning" >
                  Stages 
                </button>


              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Proficiency Test Stages <b>'{{Data_Seleted_Delete.title}}'</b> </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>

  <div class="modal-body">
    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of Data_Seleted_Delete.child">
            <tr [ngClass]="{'Start': CheckInPriodStep(item,Data_Seleted_Delete.status)}">
              <td>{{Data_Seleted_Delete.child.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.startDate}}</td>
              <td>{{item.endDate}}</td>
              <td>
                <p *ngIf="item.confirmm==1" style="color: #489b39;">Approved</p>
                <p *ngIf="item.confirmm==0" style="color: #3c399b;">Under Review</p>
                <p *ngIf="item.confirmm==-1" style="color: crimson;">Rejected</p>

              </td>
            </tr>
            <tr *ngIf="item.file.length>0">
              <td colspan="3">
                <table class="mb-0 table table-bordered table-3 text-center table-striped">
                  <thead style="background-color: #39529b; color: white;">
                    <tr>
                      <th>#</th>
                      <th>Title</th>
                      <th>Template</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let file of item.file">
                      <td>{{item.file.indexOf(file)+1}}</td>
                      <td>{{file.title}}</td>
                      <td>
                        <a class="btn btn-danger" href="{{BaseUrl}}{{file.templateSrc}}" target="_blank">
                          View File
                        </a>
                      </td>
                    </tr>          
                  </tbody>
                </table>
              </td>
            </tr>
          </ng-container>

        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">

     <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>


<ng-template #templateFile>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Stage File Management  <b>'{{Data_Seleted_Delete_Detail.title}}'</b> </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_File.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="AzmoonMaharatFileForm">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> Title </label>
          <input formControlName="title" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_FormFile_title().valid && get_FormFile_title().touched"
            class="form-text text-muted MyErrorRedColor">Please enter a title.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> File </label>
          <input #file_template (change)="UploadTemplate(file_template.files)" type="file" class="form-control"
            placeholder="Type here...">
          <small *ngIf="!get_FormFile_templateSrc().valid && get_FormFile_templateSrc().touched"
            class="form-text text-muted MyErrorRedColor">Please select a file.</small>
        </div>
      </div>

      <button *ngIf="!InProccessing" type="button" (click)="SubmitRequestSignInFile()" [disabled]="!AzmoonMaharatFileForm.valid"
        class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add  </button>
    </form>

    <br />
    <hr />
    <br />

    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>File</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Seleted_Delete_Detail.file">
           <td>{{Data_Seleted_Delete_Detail.file.indexOf(item)+1}}</td>
            <td>{{item.title}}</td>
            <td>
              <a *ngIf="item.templateSrc" class="btn btn-danger" href="{{BaseUrl}}{{item.templateSrc}}" target="_blank">
                View File
              </a>
            </td>
            <td>
              <button (click)="DeleteRequestSignInFile(item)" type="button" class="btn btn-danger"> Delete </button>
            </td>

          </tr>
        </tbody>
      </table>
   </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-info" (click)="SubmitRequestCustomerSignIn()">Submit for Review</button>
    <button type="button" class="btn btn-danger" (click)="modalRef_File.hide()">Close</button>
  </div>
</ng-template>
